<div *ngIf="notification | async as notification" [attr.class]="'cpp-notification-bar cpp-notification-bar--' + notification.type">

  <div class="cpp-notification-bar__content">

    <span class="icon icon--medium cpp-notification-bar__icon" *ngIf="notification.icon">
      <svg>
        <use [attr.xlink:href]="notification.icon"></use>
      </svg>
    </span>

    <span class="cpp-notification-bar__text">
      {{ notification.title }}
    </span>

    <a class="icon icon--medium cpp-notification-bar__close" (click)="close()">
      <svg>
        <use xlink:href="#Close"></use>
      </svg>
    </a>

  </div>

</div>
